module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_001.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_001.png
// module id = 2317
// module chunks = 5